import { render } from "./Metadata.vue?vue&type=template&id=32c1832e&scoped=true&ts=true"
import script from "./Metadata.vue?vue&type=script&lang=ts"
export * from "./Metadata.vue?vue&type=script&lang=ts"

import "./Metadata.vue?vue&type=style&index=0&id=32c1832e&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c1832e"]])

export default __exports__